angular.module('dpw.services')

    .factory('SimpleForm', [function () {
        /**
         * SimpleForm Class
         *
         * @param {Object} config               - Configuration for the form
         * @param {String} config.formName      - Name for the form
         * @param {String} config.className     - Class name for the form
         * @constructor
         */
        var SimpleForm = function (config) {
            this.formName = config.formName;
            this.className = config.className;
        };

        _.assign(SimpleForm.prototype, {
            /**
             * Get controller for the form provided by AngularJS
             *
             * @returns {Object} - Angular form controller
             */
            getFormCtrl: function () {
                var formScope = angular.element('.' + this.className).scope();
                return _.get(formScope, this.formName);
            },

            /**
             * Wrapper for `formCtrl[statusKey]`
             *
             * @param {String} statusKey
             */
            getFormStatus: function (statusKey) {
                return _.get(this.getFormCtrl(), statusKey);
            },

            /**
             * Wrapper for `formCtrl[fnName](arg1, arg2, ...)`
             *
             * @param {String} fnName
             * @param {Array<*>} args
             */
            setFormStatus: function (fnName, args) {
                var formCtrl = this.getFormCtrl();
                var setterFn = _.get(formCtrl, fnName, angular.noop);
                setterFn.apply(formCtrl, args);
            },

            /**
             * Wrapper for `formCtrl[fieldName][statusKey]`
             *
             * @param {String} fieldName
             * @param {String} statusKey
             */
            getFieldStatus: function (fieldName, statusKey) {
                return _.get(this.getFormCtrl(), [fieldName, statusKey]);
            },

            /**
             * Wrapper for `formCtrl[fieldName][fnName](arg1, arg2, ...)`
             *
             * @param {String} fieldName
             * @param {String} fnName
             * @param {Array<*>} args
             */
            setFieldStatus: function (fieldName, fnName, args) {
                var fieldCtrl = _.get(this.getFormCtrl(), fieldName);
                var setterFn = _.get(fieldCtrl, fnName, angular.noop);
                setterFn.apply(fieldCtrl, args);
            },

            /**
             * Invoke the function of each field with the arguments
             *
             * @param {String} fnName
             * @param {Array<*>} args
             */
            setFieldsStatus: function (fnName, args) {
                _.forEach(this.getFormCtrl(), function (fieldCtrl) {
                    var setterFn = _.get(fieldCtrl, fnName, angular.noop);
                    setterFn.apply(fieldCtrl, args);
                });
            }
        });

        return SimpleForm;
    }])

;